import ProtectedMenuItemLink from "../ProtectedMenuItemLink";
import React, { FC } from "react";
import notifications from "../../../pages/notifications";
import emailLogs from "../../../pages/emailLogs";
import { useSelector } from "react-redux";
import { AppState } from "../Menu";
import SectionComponent from "../SectionComponent";

interface NotificationsAndLogsMenuProps {
  permissions: string[];
}

const NotificationsAndLogsMenu: FC<NotificationsAndLogsMenuProps> = ({
  permissions,
}) => {
  const open = useSelector((state: AppState) => state.admin.ui.sidebarOpen);

  const availableResources = ["notifications", "emailSendingLogs"];

  if (permissions.length === 0) {
    return <></>;
  }

  // Give specific show menu access based on resource
  const findResources = permissions.filter((permission) =>
    availableResources.includes(permission),
  );
  if (findResources.length === 0) {
    return <></>;
  }

  return (
    <SectionComponent name={open ? "Notifications & Logs" : "N & L"}>
      <ProtectedMenuItemLink
        to={`/notifications`}
        primaryText={"Notifications"}
        leftIcon={<notifications.icon />}
        permissions={permissions}
        permissionResource="notifications"
      />
      <ProtectedMenuItemLink
        to={`/emailSendingLogs`}
        primaryText={"Email Logs"}
        leftIcon={<emailLogs.icon />}
        permissions={permissions}
        permissionResource="emailSendingLogs"
      />
    </SectionComponent>
  );
};

export default NotificationsAndLogsMenu;
